import React, { useState } from "react"; // 1. useState'i içe aktar
import moment from "moment";
import EkoModal from "../elements/EkoModal";
import Api from "../../util/Api";
import {toastr} from 'react-redux-toastr';

import { EkoFormInputText, EkoForm, EkoFormButton } from "../elements/EkoForm";


const Footer = props => {
  // 2. State tanımlama (Başlangıç değeri false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [description, setDescription] = useState("");
  // Kullanıcı bilgilerini güvenli bir şekilde al
  const user = JSON.parse(localStorage.getItem("user") || '{}');
  const saveData = () => {
    Api.post('/company/feedback', { page_link: window.location.href, description: description }, (data, errors) => {
      if (data) {
        toastr.success("Talebiniz başarıyla alındı, en kısa zamanda size dönüş yapılacak.");
        toggleModal(false);
      } else {
        toastr.error('Bir sorun oluştu lütfen bizimle iletişime geçin !');
        toggleModal(false);

      }
    });
  }

  // 3. Modal açma/kapama fonksiyonu
  const toggleModal = (value) => {
    setIsModalOpen(value);
    console.log("Modal durumu:", value); // Kontrol için
  };

  return (
    <div className="page-wrapper-row">
      <div className="page-wrapper-bottom">
        <div className="page-footer">
          <div className="container">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
              <div style={{ textAlign: "left" }}>
                Ekohesap Bilgi Teknolojileri AŞ © 2017 - {moment().year()}
              </div>

              <div style={{ textAlign: "right" }}>
                <span
                  style={{
                    cursor: "pointer",
                    marginRight: "25px",
                    color: "#ffffffff",
                  }}
                  // 4. onClick kullanımı (this ve bind gerektirmez)
                  onClick={() => toggleModal(true)}
                >
                  Geri Bildirim
                </span>
                V.{moment().year()}-{user.company_id || 'N/A'}-{user.id || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-to-top">
          <i className="icon-arrow-up" />
        </div>
      </div>
      {isModalOpen && (
        <EkoModal
          showModal={true}
          title="Geri Bildirim"
          bsSize="lg"
          onHide={() => {
            toggleModal(false)
          }}
        >
          <EkoForm>
            <div>
              <div className="alert alert-info">
                <h4 style={{ textAlign: "center", color: "#2C2C2C", fontWeight: "bold" }}>Bilgilendirme</h4>
                <p style={{ textAlign: "center", color: "#2C2C2C" }}>
                  Deneyiminizi iyileştirmemize yardımcı olun! Karşılaştığınız bir hata varsa veya sistemle ilgili bir öneriniz bulunuyorsa lütfen aşağıdan bize iletin. Hangi sayfada olduğunuzu otomatik olarak ekledik; sorunu kısaca tarif etmeniz yeterli olacaktır.
                </p>
              </div>
              <EkoFormInputText
                onChange={(_, value) => setDescription(value)}
                style={{ width: "100%" }}
                isVertical={true}
                // type="addon"
                label="Sayfa Linki"
                id=""

                value={window.location.href}
                // load={this.state.savingVkn}
                // queryVkn={this.queryVkn.bind(this)}
                disabled={true}
              />
              <EkoFormInputText
                // labelMd={6}
                // colMd={6}
                style={{ width: "100%" }}
                type="textarea"
                isVertical={true}
                value={description}
                onChange={(_, value) => setDescription(value)}
                // type="addon"
                label="Açıklama"
                id="description"
              // load={this.state.savingVkn}
              // queryVkn={this.queryVkn.bind(this)}
              />
              <div style={{ float: "right" }}>
                <EkoFormButton
                  label="Gönder"
                  faClass="fa fa-plus"
                  onClick={() => {
                    saveData();
                  }}
                /></div>
              <div style={{ clear: "both" }}></div>
            </div>
          </EkoForm>

        </EkoModal>
      )}
    </div>
  );
};

export default Footer;